import {useSiteURL} from "./state";

export const usePhoto = (image: string) => {
  const siteURL = useSiteURL();
  // if (image) return `https://www.nationalhorseman.com/${image}`;

  if (image)
    if (image.includes('null'))
      return "/noimage.jpg";
    else
      return `${siteURL.value}${image}`;
  else
    return "/noimage.jpg";
};

export const useJudgeCards = (card: string) => {
  const siteURL = useSiteURL();
  // if (image) return `https://www.nationalhorseman.com/${image}`;

  if (card)
    if (card.includes('null'))
      return "#";
    else
      return `${siteURL.value}${card}`;
  else
    return "#";
};